export var CursorState;
(function (CursorState) {
    CursorState["NONE"] = "none";
    CursorState["DEFAULT"] = "default";
    CursorState["GRAB"] = "grab";
    CursorState["GRABBING"] = "grabbing";
    CursorState["POINTER"] = "pointer";
    CursorState["CROSSHAIR"] = "crosshair";
    CursorState["MOVE"] = "move";
    CursorState["ZOOM_IN"] = "zoom-in";
    CursorState["ZOOM_OUT"] = "zoom-out";
})(CursorState || (CursorState = {}));
